import React from 'react';
import * as T from '../../../components/Table';
import { Box, CircularProgress, Flex, Icon, Text, useToast } from '@chakra-ui/react';
import { FiPlayCircle } from 'react-icons/fi';
import { GiPauseButton } from 'react-icons/gi';
import { Sound } from './Sound';
import { IoIosPhonePortrait } from 'react-icons/io';

export const Item = ({ item, isOdd }) => {
  const audioRef = React.useRef(null);
  const [audioIsPlaying, setAudioIsPlaying] = React.useState(false);
  const [currentTime, setCurrentTime] = React.useState(0);
  const [duration, setDuration] = React.useState(0);
  const [error, setError] = React.useState(null);

  const toast = useToast({
    position: 'top-right',
    duration: 3000,
    isClosable: true
  });

  function playSound() {
    if (audioIsPlaying) {
      setError('O áudio já está sendo reproduzido.');
      return;
    }
    const audio = audioRef.current;
    audio
      .play()
      .then(() => {
        setAudioIsPlaying(true);
        setDuration(audio.duration);
      })
      .catch(() => {
        setError('Não foi possível reproduzir o áudio.');
        toast({
          title: 'Erro',
          description: 'Não foi possível reproduzir o áudio.',
          status: 'error'
        });
      });
  }

  function stopSound() {
    const audio = audioRef.current;
    audio.pause();
    setAudioIsPlaying(false);
  }

  const handleTimeUpdate = () => {
    const audio = audioRef.current;
    setCurrentTime(audio.currentTime);
  };

  function onAudioEnded() {
    setAudioIsPlaying(false);
  }

  return (
    <T.Tr>
      <T.Td bgColor={isOdd ? '#EDF2F7' : 'white'}>{item.data}</T.Td>
      <T.Td bgColor={isOdd ? '#EDF2F7' : 'white'} borderLeft="1px solid #CFCFCF">
        {item.consultor}
      </T.Td>
      <T.Td bgColor={isOdd ? '#EDF2F7' : 'white'} borderLeft="1px solid #CFCFCF">
        <Flex alignItems="center" justifyContent="center" gap={2} mx="auto">
          <Icon as={IoIosPhonePortrait} fontSize="25px" color="#378BBF" />
          <strong>CELULAR:</strong> {item.telefone}
        </Flex>
      </T.Td>
      <T.Td bgColor={isOdd ? '#EDF2F7' : 'white'} borderLeft="1px solid #CFCFCF">
        {item.inicioLigacao}
      </T.Td>
      <T.Td bgColor={isOdd ? '#EDF2F7' : 'white'} borderLeft="1px solid #CFCFCF">
        {item.terminoLigacao}
      </T.Td>
      <T.Td bgColor={isOdd ? '#EDF2F7' : 'white'} borderLeft="1px solid #CFCFCF">
        {item.duracao}
      </T.Td>
      <T.Td bgColor={isOdd ? '#EDF2F7' : 'white'} borderLeft="1px solid #CFCFCF">
        <Flex
          alignItems="center"
          justifyContent="start"
          gap="10px"
          w="70px"
          mx="auto"
          position="relative">
          {!audioIsPlaying ? (
            <Box position="relative" w="25px">
              <Icon
                as={FiPlayCircle}
                fontSize="25px"
                color={!error ? '#378BBF' : 'red.500'}
                cursor="pointer"
                onClick={() => playSound()}
                position="absolute"
                top="50%"
                left="50%"
                transform="translate(-50%, -50%)"
              />
            </Box>
          ) : (
            <Box position="relative" w="25px">
              <CircularProgress
                value={(currentTime * 100) / duration}
                size="25px"
                position="absolute"
                top="50%"
                left="50%"
                transform="translate(-50%, -50%)"
                color="#378BBF"
              />
              <Icon
                as={GiPauseButton}
                fontSize="15px"
                color="#378BBF"
                cursor="pointer"
                onClick={() => stopSound()}
                position="absolute"
                top="50%"
                left="50%"
                transform="translate(-50%, -50%)"
                //cria uma borda tipo que vai ficar piscando
              />
            </Box>
          )}
          <Sound
            ref={audioRef}
            src={item.audio}
            onTimeUpdate={handleTimeUpdate}
            onAudioEnded={onAudioEnded}
          />
          {audioIsPlaying && (
            <Text
              fontSize="10px"
              color="#378BBF"
              position="absolute"
              top="50%"
              right="-25px"
              transform="translateY(-50%)">
              {currentTime.toFixed(0)}s / {duration.toFixed(0)}s
            </Text>
          )}
        </Flex>
      </T.Td>
    </T.Tr>
  );
};
